// extracted by mini-css-extract-plugin
export default {"th":"Datatable_th__ougGF","td":"Datatable_td__Iz2Ms","tr":"Datatable_tr__+L7G5","table":"Datatable_table__ZKgeB"};